import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Ligobox/vitrine_ligobox/app/[slug]/CmsPageContent.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Ligobox/vitrine_ligobox/components/FaviconInjector.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Ligobox/vitrine_ligobox/components/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Ligobox/vitrine_ligobox/components/Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Ligobox/vitrine_ligobox/components/ThemeInjector.jsx");
